import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/opt/build/repo/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const SEO = makeShortcode("SEO");
const Link = makeShortcode("Link");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <SEO title="About" mdxType="SEO" />
    <h2>{`About`}</h2>
    <p><strong parentName="p"><span className='text-hl'>{`Lex Fridman Podcast`}</span></strong>{` (previously, Artificial Intelligence Podcast), hosted by MIT professor and researcher, `}<span className='text-hl'>{`Lex Fridman`}</span>{` features conversations with a diverse range of intellectuals, including researchers, professors, entrepreneurs, founders, scientists, mathematicians, and martial artists.`}</p>
    <p><strong parentName="p"><span className='text-hl'>{`LFP Library`}</span></strong>{`™ is a fan site that provides an organized, `}<Link to="/episodes/sort" mdxType="Link">{`sortable`}</Link>{`, and searchable library of books mentioned, episodes, guest categories, stats, and articles about the Lex Fridman Podcast. You can also use the search bar to search for sections, timestamps, and books mentioned along with their authors.`}</p>
    <p>{`The `}<Link to='/changelog' mdxType="Link">{`changelog`}</Link>{` details all notable updates to LFP Library. Please feel free to contact me if you have any feedback or corrections.`}</p>
    <p className="text-gray-400 mt-4">
  <i>
    <strong>Note</strong>: As an Amazon Associate, I earn from qualifying
    purchases.
  </i>
    </p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      